import { message as antdMessage } from 'antd';
import { FC, useState, useEffect } from 'react';
import { useMessageContext } from '../../state/context/MessageContext';
import { getBleService, navigatorSupportsWebBle, requestBleDevice } from '../../services/ble/ble';
import { Button, Typography, Select } from 'antd';
import { FlexCol, FlexRow } from '../../components/common/common';
import { PairAndConnectivityWidget } from '../../components/widgets/Connection/pairAndConnectivityWidget';
import { SwapOutlined } from '@ant-design/icons';
import { colorPalette } from '../../components/widgets/Colormap/color';
import { WebBleNotSupportedWidget } from '../../components/widgets/BrowserNotSupported/webBleNotSupportedWidget';
import { CSM_PROTOCOL_COMMAND_TYPE } from '../../components/serial/csm';
import { v4 as uuidv4 } from 'uuid';

export const CsmBleConnectPage: FC = () => {
  const [isPaired, setIsPaired] = useState(false);

  const { csmIsConnected, csmBleDevice, setCSMBleDevice, setCSMIsConnected, addCSMCommand } = useMessageContext();

  // sending stop command when leaving that connect page
  useEffect(() => {
    return () => {
      addCSMCommand({
        id: uuidv4().toString(),
        message: {
          CmdType: CSM_PROTOCOL_COMMAND_TYPE.StopSampling,
        },
      });
    };
  }, []);

  if (!navigatorSupportsWebBle()) {
    return <WebBleNotSupportedWidget />;
  }

  return (
    <FlexCol
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        gap: 0,
      }}
    >
      <Typography.Title
        level={3}
        style={{
          marginBottom: 0,
        }}
      >
        {csmIsConnected ? 'Device connected' : 'Device disconnected'}
      </Typography.Title>
      <Typography.Title
        level={5}
        style={{
          marginTop: 0,
          marginBottom: 30,
        }}
      >
        {csmIsConnected ? 'You can use the app' : 'Connect NeOse to start'}
      </Typography.Title>
      <FlexRow
        style={{
          justifyContent: 'center',
        }}
      >
        <PairAndConnectivityWidget
          name=""
          isConnected={csmIsConnected}
          isPaired={isPaired}
          onPair={async () => {
            try {
              let device = await requestBleDevice();
              try {
                let service = await getBleService(device);
                if (!service) {
                  return;
                }
                setIsPaired(true);
                setCSMBleDevice(device);
                setCSMIsConnected(true);
                antdMessage.info(`Device is initializing... Please wait for the "NeOse is ready" notification`);
              } catch (e: any) {
                console.log('error getting service', e.message);
              }
            } catch (e) {}
          }}
        />
      </FlexRow>
      <FlexCol
        style={{
          marginTop: 50,
          textAlign: 'center',
          maxWidth: '80%',
        }}
      >
        <i>
          <span>
            Hint: If you are using the app for the <b>first time</b>, click on <SwapOutlined /> button to your PC to the device
          </span>
          <br />
          <span>
            You should pair <b>Aryballe Neose BLE</b> device
          </span>
        </i>
      </FlexCol>
      <FlexCol
        style={{
          marginTop: 20,
        }}
      >
        <Button
          onClick={async () => {
            if (csmBleDevice && csmBleDevice.gatt && csmBleDevice.gatt.connected) {
              void csmBleDevice.gatt.disconnect();
            }

            if (csmBleDevice && csmBleDevice.forget) {
              void (await csmBleDevice.forget());
            }
            setIsPaired(false);
            setCSMIsConnected(false);
            setCSMBleDevice(undefined);
          }}
        >
          Disconnect
        </Button>
      </FlexCol>
    </FlexCol>
  );
};
